export const PropertyComplianceSubscriptionContent = {
  section1: {
    title: "Czym jest abonament na zgodność?",
    paragraphs: [
      `To kompleksowe rozwiązanie stworzone z myślą o właścicielach i zarządcach nieruchomości wynajmowanych. Ułatwia spełnienie obowiązków przeglądów technicznych, zwiększając jednocześnie bezpieczeństwo lokatorów.`,
      `Dzięki rocznemu abonamentowi w przystępnej cenie i rabatom pakietowym, zapewnia on zgodność z przepisami oraz szybką pomoc w przypadku awarii instalacji elektrycznej, gazowej czy czujników dymu.`,
      `Abonament eliminuje kłopotliwą organizację przeglądów i pozwala mieć pewność, że nieruchomość spełnia wszystkie wymogi bezpieczeństwa.`,
    ],
  },
  section2: {
    title: "Nowe przepisy od 2021 r.",
    paragraphs: [
      `Od 2021 r. w Polsce obowiązują bardziej rygorystyczne wymagania dotyczące okresowych przeglądów instalacji w wynajmowanych nieruchomościach.`,
      `Czynności, które wcześniej miały charakter zaleceń, stały się obowiązkowe – np. przegląd instalacji gazowej i elektrycznej co 2 lata oraz coroczna kontrola czujników dymu. Jeśli nie zostały wykonane w wymaganym czasie, należy je zrealizować jak najszybciej po zakończeniu umowy najmu.`,
    ],
  },

  description:
    "Zapewnij sobie ciągłą ochronę z rabatami pakietowymi. Niedrogi roczny abonament na przeglądy elektryczne, gazowe i czujników dymu.",
  price: "Już od 1300 zł",
  year: "rok",
  note: "Abonament dostępny tylko dla nieruchomości wynajmowanych.",
  items: [
    {
      title: "Usługa kompleksowa",
      description:
        "Mniej wizyt dzięki większemu zakresowi usług oraz szybkie, niedrogie rozwiązania najczęstszych problemów.",
    },
    {
      title: "Bezproblemowe zarządzanie",
      description:
        "Raz skonfiguruj i zapomnij. Pilne naprawy są wyceniane bezpłatnie, a regularne kontrole odbywają się automatycznie, z możliwością wglądu do dokumentacji.",
    },
    {
      title: "Stała, przystępna cena",
      description: "Ciesz się stałą, niską opłatą roczną po pierwszym roku.",
    },
  ],
  seo: {
    title: "Abonament na Zgodność Nieruchomości",
    description:
      "Nasz abonament to inteligentny i przyjazny dla budżetu wybór dla proaktywnych zarządców, właścicieli domów, właścicieli nieruchomości i pośredników w obrocie nieruchomościami.",
  },
};
